module.exports = __webpack_public_path__ + "media/images/menu/pyxis-c9213057468392017b8065253a4ec0d5.jpg";